import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { voidPartnerAccountant } from '../../api/partner-accountant.ts';

export default function useVoidPartnerAccountant(): UseMutationResult<
  string,
  Error,
  string
> {
  return useMutation({ mutationFn: voidPartnerAccountant });
}
